import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Badge } from 'react-bootstrap';
import FilteredAutomationList from '../components/FilteredAutomationList';
import Breadcrumb from '../components/Breadcrumb';

const FailedAutomation = () => {
    const [selectedFilter, setSelectedFilter] = useState('all');

    const breadcrumbItems = [
        { label: 'Home', href: '/' },
        { label: 'Agent Copies', href: '/automation' },
        { label: 'Failed Agent Copies', active: true }
    ];

    const filterOptions = [
        { value: 'all', label: 'All Failed Automations', description: 'All failed runs' },
        { value: 'listing_agents_only', label: 'Listing Agents Only', description: 'Listing agents only' },
        { value: 'selling_agents_only', label: 'Selling Agents Only', description: 'Selling agents only' },
        { value: 'fsbo_no_agents', label: 'FSBO - No Agents', description: 'FSBO with no agents' },
        { value: 'agent_copy_missing', label: 'Agent Copy Missing', description: 'Missing agent copies' },
        { value: 'both_agents_missing', label: 'Both Agents Missing', description: 'Both agents missing' },
        { value: 'no_completion_status', label: 'Failed Unexpected', description: 'No completion status' }
    ];

    const handleFilterChange = (filterValue) => {
        setSelectedFilter(filterValue);
    };

    const getFilterTitle = () => {
        const filter = filterOptions.find(f => f.value === selectedFilter);
        return filter ? filter.label : 'Failed Closing Coordinator';
    };

    const getFilterSubtitle = () => {
        const filter = filterOptions.find(f => f.value === selectedFilter);
        return filter ? filter.description : 'All failed automation runs';
    };

    const getCompletionStatus = () => {
        return selectedFilter === 'all' ? null : selectedFilter;
    };

    return (
        <Container fluid className=" pt-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            <Breadcrumb items={breadcrumbItems} />
            
            

            {/* Filtered Automation List */}
            <FilteredAutomationList
                completionStatus={getCompletionStatus()}
                title={"Failed Agent Copies"}
                subtitle={"Monitor and track your Failed closing Coordinator automation"}
                breadcrumbItems={null} // We already have breadcrumb above
                status={selectedFilter === 'all' ? 'failed' : null} // Filter by failed status when showing all
            />
        </Container>
    );
};

export default FailedAutomation;